function TestController(){
	this.className	= "TestController";
	this.glob		= ["/staff/*/*/test**", "/courses/*/test**"];
	this.debug		= false;
};
TestController.inheritsFrom( StandardController );
TestController.prototype.swap = function(){
	this.$body				= $("body").find(".js-body");
	this.$page 				= this.$body.find(".js-page");

	const questions = [];
	this.$page.find(".js-question").each((i,e) => {

		const q = {};
		q.$question = $(e);
		q.$answers = q.$question.find(".js-answer");
		q.answers = [];
		q.complete = false;
		q.index = questions.length

		const correctAnswersTotal = q.$question.data('correct-answers-total');

		q.$answers.each((i,f) => {
			const $f = $(f);
			const a = {
				$answer: $f,
				$checkbox: $f.find("input:checkbox"),
				index: q.answers.length
			};
			a.$checkbox.on("change", e => {
				q.answers.forEach(a => {
					if (correctAnswersTotal === 1) {
						if(a.$checkbox[0] !== e.currentTarget) a.$checkbox.prop("checked",false);
					}
				});
				const ticked = a.$checkbox.prop("checked");
				q.complete = ticked;
				this.check();
				q.$question.removeClass("error");
			})
			q.answers.push(a)
		});
		q.reset = () => {
			q.complete = false;
			q.answers.forEach(a => a.$checkbox.prop("checked",false));
		}

		questions.push(q);
	})
	//console.log(questions)
	this.questions = questions;

	this.$finishButton = this.$page.find(".js-finish");
	this.$finishButton.on("click", e => {

		e.preventDefault();

		const $b = this.$finishButton;

		if($b.hasClass("disabled")) return false;

		$b.addClass("disabled submitting");
		$b.attr("data-main-text",$b.text());
		$b.text("Submitting...");


		const resetFunction = (hard = false) => {
			$b.text(this.$finishButton.attr("data-main-text")).removeClass("submitting").removeClass("disabled");
			if(hard){
				this.reset();
			}
		}
		const errorFunction = ( hard = false ) => {
			resetFunction();
			if(hard) $b.after("There was a problem saving your answers. Please check your internet connection.");
		}
		const successFunction = (results) => {

			resetFunction(true);
			const popup = new TestPopup({
				controller: this,
				values: results
			});
			jcache.clearCache();
		}

		const complete = this.check();

		if(!complete){

			//Display error message. Jump to first?
			const errors = this.questions.filter(q => !q.complete);
			$([document.documentElement, document.body]).animate({
				scrollTop: errors[0].$question.offset().top - 20
			}, 500);
			errors.forEach(q => {
				q.$question.addClass("error");
			});
			errorFunction();

		} else {

			const answers = this.getAllSelectedAnswersIndex(this.questions);

			$.ajax({
				url: nav.getState().nextUrl,
				data: {answers:answers},
				method: "post"
			}).then(e => {
				if(e.success){
					successFunction(e.results);
				}else{
					errorFunction(true);
				}

				return e;
			});
		}
	})

};
TestController.prototype.check = function(){
	//Check if all questions are complete
	const complete = !this.questions.some(e => !e.complete);
	return complete;
};
TestController.prototype.reset = function(){
	this.questions.forEach(q => q.reset());
};
TestController.prototype.off = function(){
  if(this.startTrainingPopup) this.startTrainingPopup.destroy();
};
TestController.prototype.getAllSelectedAnswersIndex = function(questions) {
	// Iterate through questions and answers
	// and return all the selected ones.
	let answers = []
	questions.forEach(question => {
		let answersForCurrentQuestion = [];
		question.answers.forEach((answer, answerIndex) => {
			if(answer.$checkbox[0].checked) {
				answersForCurrentQuestion.push(answerIndex);
			}
		})
		answers.push(answersForCurrentQuestion.join(','));
	})
	return answers;
}
